import {Col, Row} from "antd";
import {LiveEventEventTypeTopicTypeSingleEventStartDateFormField} from "./event-date";
import {LiveEventEventTypeTopicTypeSingleEventStartTimeFormField} from "./event-time";
import {LiveEventEventTypeTopicTypeSingleEventDurationFormField} from "./event-duration";
import {LiveEventEventTypeTopicTypeSingleEventCustomDurationFormField} from "./custom-event-duration";
import {LiveEventEventTypeTopicTypeSingleEventFormFieldProps} from "./types";

export function LiveEventEventTypeTopicTypeSingleEventFormField({
  formType,
}: LiveEventEventTypeTopicTypeSingleEventFormFieldProps) {
  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col span={24} lg={12}>
          <LiveEventEventTypeTopicTypeSingleEventStartDateFormField formType={formType} />
        </Col>
        <Col span={24} lg={12}>
          <LiveEventEventTypeTopicTypeSingleEventStartTimeFormField formType={formType} />
        </Col>
        <Col span={24} lg={12}>
          <LiveEventEventTypeTopicTypeSingleEventDurationFormField formType={formType} />
        </Col>
        <Col span={24} sm={12}>
          <LiveEventEventTypeTopicTypeSingleEventCustomDurationFormField />
        </Col>
      </Row>
    </div>
  );
}
